import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from './components/components.module';
import { DirectivesModule } from './directives/directives.module';
import { NgxBootstrapModule } from '../ngx-bootstrap/ngx-bootstrap.module';
/**
 * Shared Services
 */
import { ServicesModule } from './services/services.module';
import { PipesModule } from './pipes/pipes.module';


@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    ComponentsModule,
    DirectivesModule,
    ServicesModule,
    NgxBootstrapModule
  ],
  exports: [
    PipesModule,
    ComponentsModule,
    DirectivesModule,
    ServicesModule,
    NgxBootstrapModule
  ],
  declarations: []
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts